module.exports = __webpack_public_path__ + "static/media/standard-chartered.a8312f34.png";